import React from "react";

interface HowToImproveProps {
  title: string;
  sections: any[];
}

const HowToImprove: React.FC<HowToImproveProps> = ({ title, sections }) => {
  return (
    <div className="px-4">
      <div className="text-base font-semibold text-text-primary mb-2">
        {title}
      </div>
      {sections?.length > 0 &&
        sections?.map((section: any, index: number) => (
          <div
            key={`${section?.sectionTitle}-${index}`}
            className="mt-4 first:mt-0"
          >
            <div className="text-sm font-normal text-text-quaternary mb-2">
              {section?.sectionTitle}
            </div>
            {section?.list?.length > 0 && (
              <ul className="list-none list-inside">
                {section?.list?.map((item: string, index: number) => (
                  <li
                    key={`${item}-${index}`}
                    className="flex items-start gap-2 border-b last:border-b-0 border-gray-200 py-2"
                  >
                    <div className="w-4 h-4 bg-[var(--app-primary)] rounded-full flex-shrink-0 mt-1" />
                    <div
                      className="text-sm font-normal text-text-primary mb-2"
                      dangerouslySetInnerHTML={{
                        __html: item,
                      }}
                    />
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
    </div>
  );
};

export default HowToImprove;
